import React from "react";
import { Col, Row } from "react-bootstrap";
import RenderField from "./RenderField";

const FormBuilder = ({
  fields = [],
  handleChange = () => {},
  values,
  touched,
  errors,
  setFieldValue,
  ...props
}) => {
  return (
    <>
      {fields.map((row, rowIndex) => (
        <Row key={`root-${rowIndex}`} className="align-items-stretch">
          {row.title && <p>{row.title}</p>}
          {row.columns.map((field) => (
            <Col
              key={`sub-${rowIndex}-${field.id}`}
              md={field.colSize || Math.floor(12 / row.columns.length)}
            >
              <RenderField
                {...field}
                handleChange={handleChange}
                values={values}
                touched={touched}
                errors={errors}
                setFieldValue={setFieldValue}
                {...props}
              />
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
};

export default FormBuilder;
